
// src/firebase/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCRoUGGG-73kJ1C-UjxdDhdjUy2Dz8PW-w",
  authDomain: "jobportal-ca295.firebaseapp.com",
  projectId: "jobportal-ca295",
  storageBucket: "jobportal-ca295.appspot.com",
  messagingSenderId: "453348322667",
  appId: "1:453348322667:web:76639e20543bbe15f1b02e",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth }; // ✅ export BOTH
